import { DependencyList, useEffect, useRef } from 'react';
import { registerCprBoundaryEditHistoryHandler } from 'utils/CPRUtilities/cprBoundaryEditHistory';

export const useCprBoundaryHistoryRegistration = ({
  mainIndex,
  mode,
  undo,
  redo,
  canUndo,
  canRedo,
  deps,
}: {
  mainIndex: number;
  mode: string;
  undo: () => boolean;
  redo: () => boolean;
  canUndo: () => boolean;
  canRedo: () => boolean;
  deps: DependencyList;
}) => {
  const handlersRef = useRef({ undo, redo, canUndo, canRedo });

  useEffect(() => {
    handlersRef.current = { undo, redo, canUndo, canRedo };
  }, [undo, redo, canUndo, canRedo, ...deps]);

  useEffect(() => {
    const historyKey = `CPR.${mainIndex}.${mode}`;
    return registerCprBoundaryEditHistoryHandler(historyKey, {
      undo: () => handlersRef.current.undo(),
      redo: () => handlersRef.current.redo(),
      canUndo: () => handlersRef.current.canUndo(),
      canRedo: () => handlersRef.current.canRedo(),
    });
  }, [mainIndex, mode]);
};
